var map = {
	"./changed.png": "6010",
	"./changing.gif": "64d2",
	"./chevron.png": "1237",
	"./cigar.png": "842c",
	"./circle.png": "870f",
	"./cone.png": "207f",
	"./crescent.png": "6fa2",
	"./cross.png": "ce1a",
	"./cylinder.png": "a4ae",
	"./delta.png": "f2a5",
	"./diamond.png": "80c8",
	"./disk.png": "28d8",
	"./dome.png": "ff1d",
	"./egg.png": "d745",
	"./fireball.png": "effd",
	"./flare.png": "49f3",
	"./flash.png": "e784",
	"./formation.png": "7af1",
	"./hexagon.png": "5560",
	"./light.png": "5d47",
	"./nan.png": "bb6a",
	"./other.png": "ffa4",
	"./oval.png": "7f2e",
	"./pyramid.png": "db86",
	"./rectangle.png": "ae96",
	"./round.png": "2f69",
	"./sphere.png": "445b",
	"./teardrop.png": "d5b1",
	"./triangle.png": "c708",
	"./unknown.png": "88ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e3e";